let UTILS = require("../libs/utils.js");
module.exports = {
  id: "tdf",
  name: "Team Defender",
  alias: "tdf",
  endStats: ["sid", "name", "score", "kills", "deaths", "objective", "reward"],
  leaderStats: ["objective", "score"],
  teams: true,
  objScore: 20,
  teamCarrierMlt: 1,
  nonCarrierMlt: 0.5,
  carrierMlt: 1.25,
  onKill: function (p9260, p9261, p9262) {
    p9260.dropFlag(p9262.flag);
  },
  oneflag: true,
  update: function (game, p9264, p9265) {
    if (game.map.manager.flags.length && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && (game.objectiveTimer -= p9265, game.objectiveTimer <= 0)) {
      game.objectiveTimer = 1500;
      var v7765 = game.connectedClients < 4 && !game.hasHost() && !game.isComp;
      for (var vLN01246 = 0; vLN01246 < game.players.list.length; ++vLN01246) {
        if (game.players.list[vLN01246].active && game.players.list[vLN01246].flag) {
          game.players.score(game.players.list[vLN01246], v7765 ? 1 : game.mode && game.mode.objScore ? game.mode.objScore : 10);
        }
      }
    }
  }
};